import { render } from "./FuelSurcharge.vue?vue&type=template&id=12f0ea05&scoped=true"
import script from "./FuelSurcharge.vue?vue&type=script&lang=js"
export * from "./FuelSurcharge.vue?vue&type=script&lang=js"

import "./FuelSurcharge.vue?vue&type=style&index=0&id=12f0ea05&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f0ea05"]])

export default __exports__